import ClassNames from 'classnames'

import l10n from '../../i18n/I18N'
import { config } from '../../Init/Init'
import { withdrawalSteps } from '../cryptoPaymentConstants'
import { useCryptoPaymentDataModal } from '../CryptoPaymentModalDataProvider'
import { getThemeImageUrl } from '../../../services/utils'

import classes from './styles/cryptoPaymentWithdrawalFormButton.module.scss'

export const CryptoPaymentWithdrawalFormButton = () => {
  const { loading, withdrawalStep } = useCryptoPaymentDataModal()

  const submitButtonClassName = ClassNames(classes.cryptoPaymentWithdrawalForm__submit, {
    [classes.cryptoPaymentWithdrawalForm__submit_primary]: withdrawalStep === withdrawalSteps.submit,
    [classes.cryptoPaymentWithdrawalForm__submit_secondary]: withdrawalStep === withdrawalSteps.create
  })

  const submitTextClassName = ClassNames(classes.cryptoPaymentWithdrawalForm__submitText, {
    [classes.cryptoPaymentWithdrawalForm__submitLoading]: loading
  })

  const submitIconClassName = ClassNames(classes.cryptoPaymentWithdrawalForm__submitIcon, {
    [classes.cryptoPaymentWithdrawalForm__submitLoading]: loading
  })

  const submitButtonTitle = {
    [withdrawalSteps.create]: l10n.t['cryptopayment.redeem.estimate'],
    [withdrawalSteps.submit]: l10n.t['cryptopayment.redeem.button']
  }

  return (
    <button type="submit" className={submitButtonClassName} disabled={loading}>
      <img
        alt={l10n.t['casino.loading']}
        className={submitIconClassName}
        src={getThemeImageUrl(classes.cryptoPaymentAnimationLoading)}
      />
      <span className={submitTextClassName}>
        {config.enableSweepstakes ? submitButtonTitle[withdrawalStep] : l10n.t['cryptopayment.withdraw.button']}
      </span>
    </button>
  )
}
